import { ObjectProperty, ObjectPropertyList } from "./ObjectPropertyList";
import { DEFAULT_SECTION } from "../../config";
import React from "react";

function objectCitationString(obj) {
  //chicago citation formatted string
  const id = obj.ID[0];

  // if (obj.DATE && obj.DATE.length > 0) {
  //   elements.push(obj.DATE[0]);
  // } else if (obj.DATE_ORIG && obj.DATE_ORIG.length > 0) {
  //   elements.push(obj.DATE_ORIG[0]);
  // }

  // if (obj.PARENT && obj.PARENT.length > 0) {
  //   elements.push(obj.PARENT[0]);
  // }

  const editors = "Gasso, E., Stork, L., Weber, A. et al.";
  const publictation = "Natuurkundige Commissie Archives Online";
  const publisher = "Leiden: Brill";
  const date = "2020";
  const archive = "Naturalis Biodiversity Center Leiden; The Netherlands";

  return `${id} in ${editors} ed., <i>${publictation}</i>. ${publisher} ${date}. ${archive}.`
}

// function objectDoiUrl(obj) {
//   //todo: base on real values
//   return "https://doi.org/collection:doi#object";
// }

function objectPermanentLink(obj, section) {
  const currentUrl = new URL(window.location);
  return `${currentUrl.origin}${process.env.REACT_APP_URL_PATH}/view/${
    obj.ID[0]
  }/${section || DEFAULT_SECTION}`;
}

function objectUrn(obj) {
  return `urn:cite:visualeditions:${obj.ID[0]}`.toLowerCase();
}

function objectImageUrl(obj) {
  const currentUrl = new URL(window.location);
  return obj.ALLIMAGES.map(image => `${currentUrl.origin}${process.env.REACT_APP_URL_PATH}/f/${image}`).join(
    ", "
  );
}

const ObjectCitationPanel = ({ obj }) => (
  <ObjectPropertyList>
    <ObjectProperty label="Cite as:" value={objectCitationString(obj)} html />
    <ObjectProperty label="URN:" value={objectUrn(obj)} />
    {/* <ObjectProperty label="DOI:" value={objectDoiUrl(obj)} /> */}
    <ObjectProperty label="Permanent link:" value={objectPermanentLink(obj)} />
    {obj.ALLIMAGES[0] && (
      <ObjectProperty label="Image URL:" value={objectImageUrl(obj)} />
    )}
  </ObjectPropertyList>
);

export default ObjectCitationPanel;
